/**
 * better-auth browser client. Same-origin with the API (one Bun process), so
 * the session cookie is sent automatically on every request — no token
 * handling. The organization plugin client exposes org/active-org hooks used by
 * the header menu. The OAuth provider client signs the current page's query
 * into sign-in and consent requests, so an AI assistant's authorization resumes
 * after sign-in (see routes/consent.tsx and server/mcp.ts). The last login
 * method client reads the cookie that names the provider this browser last
 * signed in with (server/auth.ts).
 *
 * Auth endpoints live outside the Elysia `App` type (they're served at the
 * Bun.serve level), so they're called through THIS client, not the Eden `api`.
 */
import { oauthProviderClient } from "@better-auth/oauth-provider/client";
import { lastLoginMethodClient, organizationClient } from "better-auth/client/plugins";
import { createAuthClient } from "better-auth/react";

export const authClient = createAuthClient({
  plugins: [organizationClient(), oauthProviderClient(), lastLoginMethodClient()],
});

export const { signIn, signOut, useSession, getLastUsedLoginMethod } = authClient;

/**
 * An AI assistant's authorization sent the parent here: the OAuth provider
 * sends a signed `client_id` + `sig` query to its login page (`/login`).
 * The sign-in screen and its analytics both decide by this.
 */
export function isAssistantSignIn(location: { search: string }): boolean {
  const params = new URLSearchParams(location.search);
  return params.has("client_id") && params.has("sig");
}
